import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { MaintenanceGate } from "@/components/site/MaintenanceGate";
import { ImmersiveAnnouncements } from "@/components/site/ImmersiveAnnouncements";
import Site from "@/pages/Site";
import DynamicPage from "@/pages/DynamicPage";
import NewsDetail from "@/pages/NewsDetail";
import FormationsPage from "@/pages/FormationsPage";
import ProjectDetail from "@/pages/ProjectDetail";
import FormationDetail from "@/pages/FormationDetail";
import TeamMemberPage from "@/pages/TeamMemberPage";
import FestivalPage from "@/pages/FestivalPage";
import FestivalPalmaresPage from "@/pages/FestivalPalmaresPage";
import FestivalEditionPage from "@/pages/FestivalEditionPage";
import FestivalAboutPage from "@/pages/FestivalAboutPage";
import FestivalNewsPage from "@/pages/FestivalNewsPage";
import VideosPage from "@/pages/VideosPage";
import GalleryPage from "@/pages/GalleryPage";
import CalendarPage from "@/pages/CalendarPage";
import RejoindrePage from "@/pages/RejoindrePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAnalytics from "@/pages/AdminAnalytics";

const Protected = ({ children }) => {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen bg-[#050505] flex items-center justify-center"><Loader2 className="animate-spin text-electric" /></div>;
  return user ? children : <Navigate to="/admin/login" replace />;
};

function AdminRoutes() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route index element={<Protected><AdminDashboard /></Protected>} />
        <Route path="analytics" element={<Protected><AdminAnalytics /></Protected>} />
      </Routes>
    </AuthProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MaintenanceGate><ImmersiveAnnouncements /><Outlet /></MaintenanceGate>}>
          <Route path="/" element={<Site />} />
          <Route path="/actualites/:id" element={<NewsDetail />} />
          <Route path="/formations" element={<FormationsPage />} />
          <Route path="/formation/:slug" element={<FormationDetail />} />
          <Route path="/projet/:slug" element={<ProjectDetail />} />
          <Route path="/equipe/:slug" element={<TeamMemberPage />} />
          <Route path="/festival" element={<FestivalPage />} />
          <Route path="/festival/palmares" element={<FestivalPalmaresPage />} />
          <Route path="/festival/a-propos" element={<FestivalAboutPage />} />
          <Route path="/festival/actualites" element={<FestivalNewsPage />} />
          <Route path="/festival/edition/:slug" element={<FestivalEditionPage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/galerie" element={<GalleryPage />} />
          <Route path="/calendrier" element={<CalendarPage />} />
          <Route path="/rejoindre" element={<RejoindrePage />} />
          <Route path="/p/:slug" element={<DynamicPage />} />
        </Route>
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
